export const BENCH_CANDIDATES_FORM_TYPES = {
  requestRate: 'requestRate',
  requestUpdate: 'requestUpdate',
};
